import React from "react";
import { Link } from "react-router-dom";
import { useClientConfigValue } from "../../Components/Utility/Utility";

/* Client config key holding an optional destination for the header logo.
   Admins add it as a key/value row on Client Master or Client Configuration. */
const HEADER_LOGO_REDIRECT_KEY = "headerLogoRedirectUrl";

/* Turns the configured value into a destination.
   An absolute http/https URL leaves the storefront, a single leading slash
   stays an in app route, and anything else falls back to the home page so an
   unexpected config value cannot make the logo a javascript:, data: or
   protocol relative link. */
const resolveLogoDestination = (configuredUrl) => {
  const url = String(configuredUrl ?? "").trim();

  if (/^https?:\/\//i.test(url)) return { href: url };
  if (/^\/(?![/\\])/.test(url)) return { to: url };

  return { to: "/" };
};

/* Wraps the header logo. Without a configured URL it renders the same
   in app link to the home page the header has always used. */
const LogoLink = ({ className, style, children }) => {
  const configuredUrl = useClientConfigValue(HEADER_LOGO_REDIRECT_KEY);
  const destination = resolveLogoDestination(configuredUrl);

  if (destination.href) {
    return (
      <a href={destination.href} className={className} style={style}>
        {children}
      </a>
    );
  }

  return (
    <Link to={destination.to} className={className} style={style}>
      {children}
    </Link>
  );
};

export default LogoLink;
export { HEADER_LOGO_REDIRECT_KEY, resolveLogoDestination };
